/**
 * 서비스/프로젝트 상세 조회수 중복 증가 방지 (2026-08-09)
 * 같은 브라우저 탭(세션) 안에서 같은 글을 다시 열어도 조회수가 매번 올라가던 문제 수정.
 * sessionStorage에 "이번 세션에 이미 봤음" 플래그를 남겨, 두 번째부터는 백엔드에 countView=false로
 * 요청해 조회수 증가를 건너뛰게 한다. 탭을 새로 열거나 브라우저를 재시작하면 다시 카운트된다.
 */
const PREFIX = 'fm_viewed_';

export type ViewableType = 'service' | 'project';

/** fetch URL에 붙일 쿼리스트링 반환 (이미 본 적 있으면 '?countView=false', 처음이면 '') */
export function viewCountQueryParam(type: ViewableType, id: string | number): string {
  try {
    const already = sessionStorage.getItem(`${PREFIX}${type}_${id}`);
    return already ? '?countView=false' : '';
  } catch {
    return ''; // sessionStorage 접근 불가 환경(프라이빗 모드 등)이면 그냥 매번 카운트
  }
}

/** 조회 성공 후 호출 — 이번 세션에서 이 글을 봤다고 기록 */
export function markViewed(type: ViewableType, id: string | number): void {
  try {
    sessionStorage.setItem(`${PREFIX}${type}_${id}`, '1');
  } catch {
    // 무시
  }
}
